export default ({ path, props, state }) => {
  if (
    state.get('node.listType') === 'HIERARCHICALLY' &&
    state.get('node.selectedNode.id')
  )
    return path.true()
  return Object.keys(state.get('node.selectedList')).findIndex(
    nodeId => nodeId === props.node.id
  ) === -1
    ? path.false()
    : path.true()
}



// WEBPACK FOOTER //
// ./src/modules/Node/actions/isSelectedNodeAffected.js